// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"45":"255f2002b4badf94","480":"361d3235a0f088c8"}[chunkId] + ".js";
};